import React from 'react'
import { Smile, Frown } from 'lucide-react'
import { useUser } from 'util/UserContext'

type SentimentValue = -1 | 0 | 1

interface EntitySentimentButtonProps {
  variant: 'positive' | 'negative'
  sentiment: SentimentValue
  loading?: boolean
  onToggle: () => void
  className?: string
  title?: string
}

const EntitySentimentButton: React.FC<EntitySentimentButtonProps> = ({ variant, sentiment, loading = false, onToggle, className, title }) => {
  const { currentUser, setShowAuthModal } = useUser()
  const isActive = (variant === 'positive' && sentiment === 1) || (variant === 'negative' && sentiment === -1)

  // Match AlignmentStanceButton styles
  const baseBtn = `size-5 rounded-full flex items-center justify-center transition-colors ${variant === 'positive' ? 'text-green-600' : 'text-red-600'}`
  const selectedPositive = 'bg-green-600 text-white'
  const selectedNegative = 'bg-red-600 text-white'
  const unselected = 'bg-gray-200 dark:bg-eoe-dark-icon'

  const activeClass = variant === 'positive' ? selectedPositive : selectedNegative
  const classes = `${baseBtn} ${isActive ? activeClass : unselected} ${className || ''}`
  const icon = variant === 'positive' ? <Smile className="size-4" /> : <Frown className="size-4" />
  const defaultTitle = variant === 'positive' ? 'Positive' : 'Negative'

  return (
    <button
      type="button"
      title={title || defaultTitle}
      aria-label={title || defaultTitle}
      disabled={loading}
      className={classes}
      onClick={() => {
        if (!currentUser) {
          setShowAuthModal(true)
          return
        }
        onToggle()
      }}
    >
      {icon}
    </button>
  )
}

export default EntitySentimentButton


